import { userConstants } from '../user.constants';

// Only getUser()'s normalized error carries a numeric `code` (HTTP status, or 0
// offline). handleResponse's 401 logout dispatches the raw axios error, which
// never counts as transient.
const isTransient = error =>
  !!error && typeof error.code === 'number' && (error.code === 0 || error.code >= 500);

export function user(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_USER_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_USER_SUCCESS:
      return {
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        user: action.user,
      };
    case userConstants.GET_USER_FAILURE:
      // Setting error logs the user out: PrivateRoute redirects to /login on it.
      // A loaded user survives only a network or server failure; a 401, or a 403
      // from revoked access, still logs out.
      if (state.user && isTransient(action.error)) {
        return { user: state.user };
      }
      return {
        error: action.error.message
      };
    case userConstants.CLEAR_USER_STATUS:
      return {};
    case userConstants.SELECT_ACCOUNT_SUCCESS:
      return {
        user: action.user,
      };
    case userConstants.UPDATE_USER_REQUEST:
      return {
        loading: true,
        user: { ...state.user }
      };
    case userConstants.UPDATE_USER_SUCCESS:
      return {
        user: {
          ...state.user,
          ...action.result
        }
      };
    case userConstants.UPDATE_USER_FAILURE:
      return {
        user: {
          ...state.user
        }
      };
    default:
      return state;
  }
}
